// extracted by mini-css-extract-plugin
export default {"errorMain":"nNjAE_errorMain","errorMainText":"g0oRX_errorMainText"};